export default "__VITE_ASSET__6LghxyRY__"